import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import InstructorDetailsComponent from "../../../components/InstructorDetails/InstructorDetails";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import {
  getStudentByIdAPI,
  resetError,
} from "../../../redux/features/adminSlice";
import toast from "react-hot-toast";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

const InstructorDetails = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("id");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { selectedStudent, loading, error } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    if (!auth?.token) {
      toast.error("Please log in to view student details.", {
        position: "top-center",
      });
      navigate("/login");
      return;
    }
    if (!userId) {
      toast.error("Invalid student ID.", { position: "top-center" });
      return;
    }

    dispatch(getStudentByIdAPI({ token: auth.token, userId }))
      .unwrap()
      .catch((error) => {
        const errorMessage =
          typeof error === "string"
            ? error
            : error?.message || "Failed to fetch student details.";
        toast.error(errorMessage, { position: "top-center" });
      });

    return () => {
      dispatch(resetError());
    };
  }, [auth?.token, userId, dispatch, navigate]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
    {loading && (
      <div className="loader-container">
        <div className="dottedLoading theme-color"></div>
      </div>
    )}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ad-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Instructor Details
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            {auth.role === "Admin" ? (
              <AdminNotification />
            ) : auth.role === "Instructor" ? (
              <InstructorNotification />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {!loading && !error && selectedStudent && (
        <InstructorDetailsComponent userId={userId} />
      )}
    </>
  );
};

export default InstructorDetails;
